export default {"src":"/_next/static/media/no_flag.4bc002c3.svg","height":16,"width":16,"blurWidth":0,"blurHeight":0};